<template>
    <article class="article">
        <div class="inner">
            <div class="article-header">
                <h4 class="h6 byline">{{ byline }}</h4>
                <h1 class="h1">{{ title }}</h1>
                <div class="meta-row">
                    <h6 class="h6">
                        <span v-if="tags" class="tags">{{ tags.join(', ') }}</span>
                        <span v-if="date" class="date">{{ date }}</span>
                    </h6>
                    <DSSomeShare :sharing="sharing" />
                </div>
            </div>
            <DSFrontifyAsset
                :asset="{ ...image?.[0], alt: alt || image?.[0]?.alt }"
                class="main-image"
            />
            <div class="article-body">
                <DSCFText :content="articleContent" hide-some-icons />
                <hr>
                <div class="share">
                    <DSSomeShare :sharing="sharing" />
                </div>
            </div>
        </div>
    </article>
</template>
<script setup>
import { computed, useRoute, useHead, onMounted } from '#imports';
import { DateTime } from 'luxon';
import { usePageStore } from '~dsc/stores/cms/page';
const pageStore = usePageStore();
const route = useRoute();

useHead({
    bodyAttrs: {
        class: 'article',
    },
});

onMounted(()=>{
    window.dataLayer.push({
        event: 'article_loaded',
        article_name: props.title,
        article_category: props.tags.join(', '),
        article_published: date.value,
    });
});

const props = defineProps({
    id: {
        type: String,
        required: false,
        default: '',
    },
    contentType: {
        type: String,
        required: false,
        default: 'articleBlock',
    },
    title: {
        type: String,
        default: '',
        required: false,
    },
    byline: {
        type: String,
        default: '',
        required: false,
    },
    image: {
        type: Array,
        default: () => [],
        required: false,
    },
    alt: {
        type: String,
        default: null,
        required: false,
    },
    created: {
        type: String,
        default: '',
        required: false,
    },
    articleContent: {
        type: Object,
        default: () => {}, // eslint-disable-line no-empty-function
        required: false,
    },
    tags: {
        type: Array,
        default: () => [],
        required: false,
    },
});

const date = computed(() => DateTime.fromISO(props.created).toFormat('d.M.yyyy'));

const sharing = computed(() => ({
    title: props.title,
    url: `${window?.location.protocol}//${window?.location.host}${route.path}`,
    description: pageStore.meta.description,
    quote: '',
    hashtags: '',
}));
</script>
<style scoped>
.article {
  display: grid;
  max-width: var(--desktop-max-width);
  width: 100%;
  margin: 0 auto;
}
.article .inner {
  max-width: var(--page-max-width);
  margin: 0 auto;
  padding-left: 1.5rem;
  width: 100%;
  padding-right: 1.5rem;
}

.article-header {
  padding: 0 0 1.5rem;
}
.article-header h6 {
  color: var(--color-base-grey-500);
  margin: 0;
}

.meta-row {
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
}
@media (max-width: 767px) {
  .meta-row {
    grid-template-columns: 1fr;
  }
  .meta-row div:last-child {
    text-align: left;
  }
}

.some-share {
  justify-content: flex-end;
}

.byline + .h1 {
  margin-top: 0;
}

.h1 {
  text-align: left;
}

.tags::after {
  content: "|";
  margin-inline: 0.25rem;
}

.main-image {
  padding-top: 48.6%;
  height: 0;
}

.article-body {
  margin: 2rem auto;
  padding: 0 10rem;
}
.article-body hr {
  margin: 2rem 0;
}
@media (max-width: 991px) {
  .article-body {
    padding: 0;
  }
}
</style>
